// Example usage:
// const cardNumber = '4235 1234 5678 9010';
// const brand = detectCardBrand(cardNumber); // 'visa'
import { CardBrand } from "@/components/Payment/PaymentForm/enums/CardBrand.ts";

export const detectCardBrand = (cardNumber: string): CardBrand | undefined => {
  // Remove spaces from the card number
  const normalizedCardNumber = cardNumber.replace(/\s/g, "");

  // Define patterns for each card brand
  // NOTE: To render proper imgs for cards keep key names same as images in
  // cardBrand folder - src/assets/cardBrand
  const patterns = {
    [CardBrand.Visa]: /^4/,
    [CardBrand.Mastercard]: /^5[1-5]/,
    [CardBrand.Amex]: /^3[47]/,
    [CardBrand.Discover]: /^6(?:011|5)/,
    [CardBrand.Diners]: /^3(?:0[0-5]|[68][0-9])[0-9]/,
    [CardBrand.Jcb]: /^(?:2131|1800|35)/,
  };

  // Check the card number against each pattern
  for (const [brand, pattern] of Object.entries(patterns)) {
    if (normalizedCardNumber.match(pattern)) {
      return brand?.toLowerCase() as CardBrand;
    }
  }

  // If no pattern matches, return "unknown"
  return;
};
